import { render, staticRenderFns } from "./AnyPieChart.vue?vue&type=template&id=6d35b7e8&scoped=true&"
import script from "./AnyPieChart.vue?vue&type=script&lang=js&"
export * from "./AnyPieChart.vue?vue&type=script&lang=js&"
import style0 from "./AnyPieChart.vue?vue&type=style&index=0&id=6d35b7e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d35b7e8",
  null
  
)

export default component.exports